import React from "react";
import styles from "./Loader.module.css";

export default function Loader({
  top = "",
  left = ""
}) {
  return (
    <div className={styles.load_wrapper} style={{top : top, left : left}}>
      <div className={styles.lds_ring}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
